module.exports = __webpack_public_path__ + "img/wg.a2af7dd6.jpg";